// Brand-derived categorical palette for charts, validated for THIS order on a
// white surface (dataviz six checks: lightness band, chroma floor, CVD ΔE ≥ 8,
// normal-vision ΔE ≥ 15). Slots 1/3/4 are the Surelia families (azul-surelia,
// cian-digital, verde-lima) stepped into the legible band — the raw brand hexes
// fail as series marks (azul too dark, lime invisible on white).
// The slot ORDER is the colorblind-safety mechanism — never re-sort or cycle it.
// Aggregate/"Otros" buckets are always gray, never a series color.
export const SERIES_COLORS = ['#2e6da6', '#e0862f', '#3fb3cf', '#8f9e0e', '#b25fa5', '#35843c', '#6d5cc4', '#cf5348'];
export const OTROS_COLOR = '#898781';
